const collapseSelector = state => state.project.header.collapse
const collapsingSelector = state => state.project.header.collapsing
const stickySelector = state => state.project.header.sticky
const moreInfoCollapseSelector = state => state.project.header.moreInfoCollapse
const relatedProjectsCollapseSelector = state => state.project.header.relatedProjects.collapse
const relatedProjectsShowAllSelector = state => state.project.header.relatedProjects.showAll

export {
    collapseSelector,
    collapsingSelector,
    stickySelector,
    moreInfoCollapseSelector,
    relatedProjectsCollapseSelector,
    relatedProjectsShowAllSelector
}

